// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2dZMU","gfeWrapper":"CalendarEvent_gfeWrapper__1nfOY"};